
import { supabase } from '../client';

export async function checkSlugExists(slug: string): Promise<boolean> {
  if (!slug) return false;
  
  const { data } = await supabase
    .from('shops')
    .select('id')
    .eq('slug', slug)
    .limit(1);
    
  return data && data.length > 0;
}

export function generateSlugFromName(name: string): string {
  return name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

export async function generateUniqueSlug(name: string): Promise<string> {
  if (!name) return '';
  
  const baseSlug = generateSlugFromName(name);
    
  let slug = baseSlug;
  let count = 1;
  
  while (await checkSlugExists(slug)) {
    slug = `${baseSlug}-${count}`;
    count++;
    console.log(`Slug ${baseSlug} existe déjà, essai avec ${slug}`);
  }
  
  return slug;
}
